export default __webpack_public_path__ + "d7b0cfcd5351d7650c1eef9b79259890.png";